module.exports = __webpack_public_path__ + "img/账户登录.fedf4f1a.png";